import { EnumSiNoTodos, FilterSearchingBaseViewModel, PagingResultsViewModel } from 'src/app/components/core/_infrastructure/types/common';

export class VariedadItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: TVariedadViewModel[];
}

export class FilterSearchingTVariedadViewModel extends FilterSearchingBaseViewModel {
    public Id: number | null;
    public IdEspecie: number;
    public Descripcion = '';
    public IdGrupo: number | null;
    public IdForma: number | null;
    public NombreComun = '';
    public NombreCientifico = '';
    public CodigoEppo = '';
    public HabilitadaImportacion: number = EnumSiNoTodos.TODOS;
    public HabilitadaExportacion: number = EnumSiNoTodos.TODOS;
    public HabilitadaChina: number = EnumSiNoTodos.TODOS;
    public Activo = false;
}

export class TVariedadViewModel {
    public Id: number | null;
    public IdEspecie: number;
    public Descripcion: string;
    public Grupo: string;
    public Forma: string;
    public NombreComun: string;
    public NombreCientifico: string;
    public IdNombreCientifico: number;
    public CodigoEppo: string;
    public HabilitadaImportacion: number = EnumSiNoTodos.TODOS;
    public HabilitadaExportacion: number = EnumSiNoTodos.TODOS;
    public HabilitadaChina: number = EnumSiNoTodos.TODOS;
    public Activo = false;
}

export class TwTcVariedadCamViewModel {
    public Id: number | null;
    public Descripcion: string;
    public IdNombreCientifico: number;
    public IdEspecie: number | null;
    public Activo = false;
}
